import { Controller } from 'stimulus';

// Attached to a `<details>` rendered *inside* a Tabulator cell.
//
// Tabulator measures each row's height once, at render time, and doesn't
// observe later DOM changes inside a cell. So a `<details>` that expands or
// collapses after render would be clipped by the row's fixed height (the
// disclosed list is unreadable). On every toggle we bubble an event up to the
// enclosing `tabulator-table` controller, which re-measures the row so the
// row grows/shrinks to fit the disclosed content.
export default class extends Controller {
  remeasure() {
    this.dispatch('cell-content-toggled', {
      prefix: 'tabulator-table',
      bubbles: true,
    });
  }
}
